import React, {ErrorInfo} from 'react';
import root from 'window-or-global';
import {emitEvent, setDefaultEventCategory} from 'epic-ue-shared/dist/utils/analyticsUtils';
import {extractSlugLocale} from '@epic-core/localization';
import {App} from './App';
import {getLocale} from '@epic-core/common';
import {EpicgamesUIAppContext} from './EpicgamesUIAppContext';
import {setLocaleClassOnBody, initBowser, setUserAgent} from '@epic-mw/deprecated-utils';

const sendAnalytics = (props): void => {
    const location = props.location || {};
    const {pageSlug} = extractSlugLocale(location.pathname, getLocale());
    const nav = root._epicGamesNav || {};
    const browser = nav.browser || {};
    emitEvent({
        eventAction: 'client.load',
        interactionType: 'init',
        eventLabel: pageSlug
    });
    if (browser.name) {
        emitEvent({
            eventAction: 'client.browser',
            interactionType: 'init',
            eventLabel: `${browser.name} ${browser.version}`
        });

        emitEvent({
            eventAction: 'client.browser.os',
            interactionType: 'init',
            eventLabel: `${browser.osname} ${browser.osversion}`
        });
    }
    root.addEventListener('beforeunload', () => {
        emitEvent({
            eventAction: 'client.unload',
            interactionType: 'exit',
            eventLabel: Date.now() - root.unrealEngine_start
        });
    });
};

interface Properties {
    cmsPage: boolean;
    supportedLocales: Array<{name: string; lang: string}>;
    locale: string;
}

export default class Entry extends React.Component<Properties> {
    componentDidMount(): void {
        initBowser();
        setUserAgent();
        setLocaleClassOnBody(getLocale());

        setDefaultEventCategory('EG_SITE');
        sendAnalytics(this.props);

        const jssStyles = root.document.querySelector('#jss-server-side-mui');
        if (jssStyles && jssStyles.parentNode) {
            jssStyles.parentNode.removeChild(jssStyles);
        }
    }

    componentDidCatch(error: Error, info: ErrorInfo): void {
        console.log('componentDidCatch', info);
        console.error('Entry componentDidCatch() caught an error');
        console.error(error);

        emitEvent({
            eventAction: 'client.error',
            eventLabel: error.message
        });

        setTimeout(() => {
            root.location.href = `/${getLocale()}/error-500?e=entrydidcatch`;
        }, 500);
    }

    render(): React.ReactNode {
        return (
            <EpicgamesUIAppContext>
                <App {...this.props} />
            </EpicgamesUIAppContext>
        );
    }
}
